import { FolderOpenOutlined } from "@ant-design/icons";
import Notiflix from "notiflix";
import { useMemo, useState } from "react";

//PROJECT IMPORTS
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";

import {
  Button,
  Checkbox,
  Col,
  Modal,
  Pagination,
  Row,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";

// import { apiConfig, labelConfig } from "../../../contractbooking.config";
import { apiConfig, labelConfig } from "../wallet.config";

import ArrowLeft from "@untitled-ui/icons-react/build/esm/ArrowLeft";
import ArrowRight from "@untitled-ui/icons-react/build/esm/ArrowRight";
import "../../../../../assets/styles/InterbankPlacement.css";
import styles from "../../../../../assets/styles/styles";
import DownloadTableButtons from "../../../../../components/layouts/enhancement/DownloadTableButtons";

const { Text } = Typography;

const Transactions = (props) => {
  const {
    transactionsList,
    state,
    userData,
    showInterestChecked,
    setShowInterestChecked,
  } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const filteredTransactions = useMemo(() => {
    if (showInterestChecked) {
      return transactionsList;
    } else {
      return transactionsList.filter((transaction) => {
        const transactionType =
          transaction.transactionType?.toLowerCase() || "";
        return (
          !transactionType.includes("interest") &&
          !transactionType.includes("accrual")
        );
      });
    }
  }, [transactionsList, showInterestChecked]);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return;
    }
    if (type === "next") {
      return;
    }
    return originalElement;
  };

  const totalPages = Math.ceil(filteredTransactions.length / pageSize);

  const paginatedData = filteredTransactions.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Reset to page 1 when filter changes
  useState(() => {
    setCurrentPage(1);
  }, [showInterestChecked]);

  const columns = [
    // {
    //   title: "ID",
    //   dataIndex: "id",
    //   sorter: (a, b) => String(a.id || "").localeCompare(String(b.id || "")),
    // },
    {
      title: "Transaction Ref",
      dataIndex: "transactionRef",
      render: (text) => (
        <Tooltip title={text || "-"} placement="topLeft">
          {text ? BOM.SubstringFormat(text, 14) : "-"}
        </Tooltip>
      ),
    },
    {
      title: "Transaction Date",
      dataIndex: "transactionDate",
      sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
    },
    {
      title: "Transaction Type",
      dataIndex: "transactionType",
      render: (text) => (
        <Text style={{ textTransform: "capitalize" }}>{text}</Text>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },

    {
      title: "Actions",
      render: (_, record) => (
        <>
          <DetailTransactions
            currentContractObj={state}
            userData={userData}
            transactionObj={record}
            // refreshList={getClientLimit}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <Row
        // justify="space-between"
        // style={{
        //   display: "grid",
        //   gridTemplateColumns: "1fr auto",
        //   marginBottom: 24,
        // }}
        justify="end"
        style={{
          marginBottom: 24,
        }}
      >
        {/* <Col>
          <Checkbox
            className="check-ant-design"
            id="transactions"
            checked={showInterestChecked}
            onChange={(e) => setShowInterestChecked(e.target.checked)}
          />{" "}
          <span>Show Interest</span>
        </Col> */}

        <Col>
          <DownloadTableButtons
            downloadData={filteredTransactions}
            columns={columns}
            fileName={"Interbank Contract Transaction List"}
          />
        </Col>
      </Row>

      <Table columns={columns} dataSource={paginatedData} pagination={false} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <div>
          <Button
            style={{
              backgroundColor: "white",
              borderRadius: 8,
              border: "1px solid #D0D5DD",
              padding: "8px 12px",
              fontSize: "14px",
              fontWeight: "600",
            }}
            className="previous-button"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            <ArrowLeft style={{ width: "20px", height: "20px" }} /> Previous
          </Button>
        </div>

        {/* Centered Pagination */}
        <div style={{ flex: 1, textAlign: "center" }}>
          <Pagination
            className="payment-pagination"
            current={currentPage}
            total={filteredTransactions.length}
            pageSize={pageSize}
            onChange={(page) => setCurrentPage(page)}
            showSizeChanger={false}
            itemRender={itemRender}
            align="center"
          />
        </div>

        {/* Next button on the right */}
        <div>
          <Button
            style={{
              backgroundColor: "white",
              borderRadius: 8,
              border: "1px solid #D0D5DD",
              padding: "8px 12px",
              fontSize: "14px",
              fontWeight: "600",
            }}
            className="previous-button"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage >= totalPages}
          >
            Next <ArrowRight style={{ width: "20px", height: "20px" }} />
          </Button>
        </div>
      </div>
    </>
  );
};

export default Transactions;

const DetailTransactions = (props) => {
  const { currentContractObj, userData, transactionObj } = props;

  const { session } = userData;

  const [transactionsDetail, setTransactionsDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.InterbankContract}/${currentContractObj.id}/transactions/${transactionObj.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setTransactionsDetail(objDetail);
        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onUndoTransaction = (key) => {
    const formValues = {};

    formValues.transactionAmount = key?.amount;
    formValues.transactionDate = BOM.DateTime(key.date, "only-date");
    formValues.dateFormat = "dd MMMM yyyy";

    let action = "Reverse ";
    let label = "Transaction";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const params = {
          command: "undo",
        };
        const url = `${apiConfig.savingsAccounts}/${currentContractObj.id}/transactions/${transactionObj.id}`;

        const body = {
          method: "POST",
          locale: "en",
          ...formValues,
          session,
          params,
        };

        // message.warning(
        //   "Close or Re-Open module is not ready require some works from the backend"
        // );
        // return;
        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.undoTransactionMsg);

            // close modal
            setIsModalOpen(false);

            //refresh the list
            // refreshList();

            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      }
    );
  };

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          // type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="detail-btn"
          style={{
            backgroundColor: "#FDF4FF",
            border: "none",
            color: "#ba24d5",
          }}
        />
      </Tooltip>
      <Modal
        title="Transaction Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row gutter={[48, 24]} style={{ marginTop: 30 }}>
            <Col span={12}>
              <Space direction="vertical" size={2}>
                <Text style={{ fontSize: "14px", color: "#6B7280" }}>
                  Transaction ID
                </Text>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#1F2937",
                  }}
                >
                  {transactionsDetail?.id || "-"}
                </div>
              </Space>
            </Col>

            <Col span={12}>
              <Space direction="vertical" size={2}>
                <Text style={{ fontSize: "14px", color: "#6B7280" }}>
                  Transaction Type
                </Text>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#1F2937",
                  }}
                >
                  <Tag
                    style={{
                      backgroundColor: "#F9FAFB",
                      color: "#344054",
                      border: "1px solid #D0D5DD",
                      padding: "2px 10px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: 500,
                      textTransform: "capitalize",
                    }}
                  >
                    {transactionsDetail?.transactionType?.value?.replace(
                      "actionType.",
                      ""
                    ) || "-"}
                  </Tag>
                </div>
              </Space>
            </Col>

            <Col span={12}>
              <Space direction="vertical" size={2}>
                <Text style={{ fontSize: "14px", color: "#6B7280" }}>Date</Text>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#1F2937",
                  }}
                >
                  {BOM.FormatArrayDate(transactionsDetail?.dateOf)}
                </div>
              </Space>
            </Col>

            <Col span={12}>
              <Space direction="vertical" size={2}>
                <Text style={{ fontSize: "14px", color: "#6B7280" }}>
                  Currency
                </Text>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#1F2937",
                  }}
                >
                  {transactionsDetail?.currency?.displayLabel ||
                    "Nigerian Naira"}
                </div>
              </Space>
            </Col>

            <Col span={12}>
              <Space direction="vertical" size={2}>
                <Text style={{ fontSize: "14px", color: "#6B7280" }}>
                  Amount
                </Text>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#1F2937",
                  }}
                >
                  {transactionsDetail?.amount?.toLocaleString()}
                </div>
              </Space>
            </Col>

            <Col span={12}>
              <Space direction="vertical" size={2}>
                <Text style={{ fontSize: "14px", color: "#6B7280" }}>
                  Reversed
                </Text>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#1F2937",
                  }}
                >
                  <Tag
                    style={{
                      backgroundColor: "#F9FAFB",
                      color: "#344054",
                      border: "1px solid #D0D5DD",
                      padding: "2px 10px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {transactionsDetail?.reversed ? "Yes" : "No"}
                  </Tag>
                </div>
              </Space>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
